import { Check, ShieldCheck, Lightbulb } from 'lucide-react';

export default function ProDescription({ product }) {
  const pro = product.pro;
  if (!pro) return null;
  return (
    <section data-testid="pro-description" className="mt-20">
      <div className="bg-essenya-ink text-white rounded-[2rem] p-8 md:p-14 relative overflow-hidden">
        <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-essenya-champagne/10 blur-3xl" />
        <div className="relative max-w-3xl">
          <div className="text-eyebrow text-white/60 mb-4">Essenya Professional</div>
          <h2 className="font-display text-3xl md:text-5xl leading-[1.08] font-medium mb-4">{product.name}</h2>
          {pro.tagline && <p className="font-display text-xl md:text-2xl text-essenya-champagne mb-5">{pro.tagline}</p>}
          {pro.intro && <p className="text-white/80 leading-relaxed">{pro.intro}</p>}
        </div>
      </div>

      {pro.sections?.map((s, i) => (
        <div key={i} className="mt-10" data-testid={`pro-section-${i}`}>
          <h3 className="font-display text-2xl md:text-3xl mb-6">{s.title}</h3>
          {s.text && <p className="text-essenya-text leading-relaxed mb-4">{s.text}</p>}
          {s.items && (
            <div className="grid sm:grid-cols-2 gap-3">
              {s.items.map((it, j) => (
                <div key={j} className="bg-white rounded-2xl border border-essenya-border p-5 flex items-start gap-3">
                  <span className="mt-0.5 w-6 h-6 rounded-full bg-essenya-ink text-white flex items-center justify-center flex-shrink-0"><Check size={14} strokeWidth={2.5} /></span>
                  <span className="text-essenya-text leading-relaxed text-sm">{it}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}

      {pro.specs && (
        <div className="mt-10 bg-essenya-surface2 rounded-[2rem] p-8 md:p-10">
          <div className="flex items-center gap-3 mb-6"><ShieldCheck size={24} strokeWidth={1.5} /><h3 className="font-display text-2xl md:text-3xl">Specifiche tecniche</h3></div>
          <ul className="space-y-3">
            {pro.specs.map(([k, v], i) => (
              <li key={i} data-testid={`pro-spec-${i}`} className="flex items-start gap-3 text-essenya-text leading-relaxed"><span className="text-essenya-ink font-medium min-w-[120px]">{k}:</span> <span>{v}</span></li>
            ))}
          </ul>
        </div>
      )}

      {pro.tip && (
        <div className="mt-6 bg-essenya-champagne/30 rounded-[2rem] p-8 flex items-start gap-3">
          <Lightbulb size={22} strokeWidth={1.5} className="mt-0.5" />
          <div><p className="font-display text-lg mb-1">Il consiglio in più</p><p className="text-essenya-text leading-relaxed">{pro.tip}</p></div>
        </div>
      )}
    </section>
  );
}
